( function( global, $ ) {

    $('[gr-modal]').magnificPopup({
        type: 'inline'
    });

    $('[gr-modal-image]').magnificPopup({
        type: 'image'
    });

    $('[gr-modal-gallery]').each(function() {
        $(this).magnificPopup({
            delegate: 'a',
            type: 'image',
            preload: [0, 3],
            gallery: {
                enabled: true
            }
        });
    });

    $('[gr-modal-inline]').magnificPopup({
        type: 'inline',
        delegate: 'a[gr-modal-inline-target]',
        gallery: {
            enabled: true
        }
    });

    if ( $('[gr-modal-fabrics]') ) {
        $('[gr-modal-fabrics]').magnificPopup({
            type: 'inline',
            delegate: 'a[gr-modal-fabrics-target]'
        });
    }


    var $gr_modal_home = $('#gr-modal-home');

    if ($gr_modal_home.length > 0) {
        $.magnificPopup.open({
            items: {
                src: $gr_modal_home
            },
            type: 'inline',
            callbacks: {
                open: function () {
                    $gr_modal_home.css('display', 'block');
                }
            }
        }, 0);
    }




}( window.groots, jQuery, require('magnific-popup') ));
